import { Zap, Bot, User, Calendar, MessageSquare, Clock, TrendingDown } from 'lucide-react';

import type { FlowAction, FlowItemModel } from '@lume/shared/worklist';

const ICON: Record<string, typeof User> = {
  'fi--ai': Bot,
  'fi--money': Zap,
  'fi--cal': Calendar,
  'fi--sup': MessageSquare,
  'fi--person': User,
  // S5 (maré baixa produtiva) — M6 (pendência vencida) / M7 (sentimento em queda).
  'fi--pendency': Clock,
  'fi--sentiment': TrendingDown,
};

export function FlowItem({
  item,
  onAction,
  onOpen,
}: {
  item: FlowItemModel;
  onAction: (a: FlowAction) => void;
  onOpen: (item: FlowItemModel) => void;
}): JSX.Element {
  const Icon = ICON[item.iconKind] ?? User;
  return (
    <div
      className={`flow flow--${item.kind}`}
      role="button"
      aria-label={`Abrir ${item.title}`}
      tabIndex={0}
      onClick={() => onOpen(item)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') onOpen(item);
      }}
    >
      <div className={`flow__icon ${item.iconKind}`}>
        <Icon size={18} />
      </div>
      <div className="flow__body">
        <div className="flow__title">
          {item.title}
          {item.pills.map((p, i) => (
            <span key={i} className={`pill pill--${p.kind}`}>
              {p.label}
            </span>
          ))}
        </div>
        {item.why !== '' && <div className="flow__why">{item.why}</div>}
      </div>
      <div className="flow__act">
        {item.actions.map((a, i) => (
          <button
            key={i}
            type="button"
            className={`minibtn ${a.primary === true ? 'minibtn--primary' : ''} ${a.kind === 'retomar' || a.kind === 'delegar' ? 'minibtn--ai' : ''}`}
            aria-label={`${a.label} — ${item.title}`}
            onClick={(e) => {
              e.stopPropagation();
              onAction(a);
            }}
          >
            {a.label}
          </button>
        ))}
      </div>
    </div>
  );
}
